export default "__VITE_ASSET__Cf77PLox__"